import React from 'react';

import {
  HStack, Text, StackProps, Menu, MenuButton, MenuList, MenuItem,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { logout } from 'api/auth';
import { Avatar, Button, Icon } from 'components';
import BioCtrlLogo from 'components/svg/logo';
import useUser from 'stores/useUser';

function UserBadge() {
  const { user } = useUser();
  return (
    <HStack
      bg="gray.50"
      p={2}
      borderRadius={100}>
      <Avatar
        src={user?.avatarUrl}
        name={user?.name}
        size="xs"
        border="2px solid"
        borderColor="white"
      />
      <Text
        variant="smallRegular"
        color="gray.500">
        {user?.name}
      </Text>
      <Icon
        name="angle-down"
        color="gray.400"
      />
    </HStack>
  );
}

function UserMenu() {
  const { push } = useHistory();
  const { setLogout } = useUser();
  return (
    <Menu>
      <MenuButton>
        <UserBadge />
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => push('/profile')}>
          <Text>Meu perfil</Text>
        </MenuItem>
        <MenuItem onClick={async () => {
          setLogout();
          push('/login');

          await logout();
        }}>
          <Text>Sair</Text>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}

function LoginButton() {
  const { push } = useHistory();
  return (
    <Button
      variant="secondary.teal"
      size="xs"
      cursor="pointer"
      onClick={() => push('/login')}>
      <Icon
        name="sign-in"
        family="far"
      />
      <Text ml={2}>Entrar</Text>
    </Button>
  );
}

export default function NavBar(props : StackProps) {
  const { token } = useUser();
  return (
    <HStack
      justifyContent="space-between"
      shadow={1}
      bg="white"
      spacing={6}
      p={6}
      h={14}
      align="center"
      position="sticky"
      top={0}
      zIndex={2000}
      {...props}>
      <BioCtrlLogo mode="dark" />
      {token ? <UserMenu /> : <LoginButton />}
    </HStack>
  );
}
